import { render, staticRenderFns } from "./setting-safety.vue?vue&type=template&id=46db17b6&scoped=true&"
import script from "./setting-safety.vue?vue&type=script&lang=js&"
export * from "./setting-safety.vue?vue&type=script&lang=js&"
import style0 from "./setting-safety.vue?vue&type=style&index=0&id=46db17b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46db17b6",
  null
  
)

export default component.exports